"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatNumericField = exports.trimEndingZero = void 0;
var ValidatorUtils_1 = require("./ValidatorUtils");
/**
 * Remove ending zeros for a stringified number. E.x. 12.30000 -> 12.3
 * @param val
 * @returns
 */
var trimEndingZero = function (val) {
    return val.replace(/\.?0*$/, '');
};
exports.trimEndingZero = trimEndingZero;
/**
 * Formatter used by Einstein for numbers
 * @param options
 * @returns formatted number
 */
var formatNumericField = function (option) {
    var inputValue = option.value, fractionDigits = option.fractionDigits, isPercent = option.isPercent;
    var isValid = (0, ValidatorUtils_1.isValidObject)(inputValue);
    if (!isValid) {
        return '-';
    }
    if (isNaN(inputValue)) {
        return '-';
    }
    var value = Number(inputValue);
    var fixedDigit = fractionDigits || 2;
    return (0, exports.trimEndingZero)(value.toFixed(fixedDigit)) + (isPercent ? '%' : '');
};
exports.formatNumericField = formatNumericField;
//# sourceMappingURL=NumberUtils.js.map